
/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
(function () {

  var rul = {};
  var msg = {};
  var glp = {};
  var getMsg = window.ohValidateGetMsg; //先にjs/validation/common.jsを読み込んでおく

  // メールアドレス
  rul['mail_address'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['mail_address'] = {
    required:getMsg('required','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','メールアドレス'),
  };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());

/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {
}());
